import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useAvailabilityOverridesUnsavedChangesModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.updateAvailabilityOverridesUnsavedChangesModalState, ...args };
    updateGlobalState({ updateAvailabilityOverridesUnsavedChangesModalState: newState });
  };

  return {
    close: () => setState({ endDate: null, isOpen: false, startDate: null }),
    endDate: state.updateAvailabilityOverridesUnsavedChangesModalState.endDate,
    isOpen: state.updateAvailabilityOverridesUnsavedChangesModalState.isOpen,
    open: (startDate, endDate) => setState({ endDate, isOpen: true, startDate }),
    startDate: state.updateAvailabilityOverridesUnsavedChangesModalState.startDate,
  };
}
